/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaHandHolding } from 'react-icons/fa';
import cTokens from '../../../../Fct/tokens/cTokens.json';
import { compoundTokens } from '../constants';
export var Borrow = createPlugin({
    protocol: 'COMPOUND_V2',
    type: 'ACTION',
    method: 'borrow',
    description: 'Borrow ETH or ERC20 tokens',
    supportedContracts: cTokens,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'ctoken',
                    options: compoundTokens.filter(function (token) { return token.chainId === Number(chainId); }),
                    isPreview: true,
                    icon: FaHandHolding
                }),
                methodParams: {
                    borrowAmount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                },
            },
            output: { result: new FctValue({ innerIndex: 0 }) },
        });
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var _a;
        var to = params.to, borrowAmount = params.methodParams.borrowAmount;
        if (!borrowAmount.value || !to.value || !vaultAddress)
            return [];
        if (typeof borrowAmount.value !== 'string' || typeof to.value !== 'string')
            return [];
        // Find asset from cToken address
        var asset = (to === null || to === void 0 ? void 0 : to.value) && ((_a = compoundTokens.find(function (token) { return token.address === to.value; })) === null || _a === void 0 ? void 0 : _a.assetAddress);
        if (!asset)
            return [];
        return [
            {
                address: vaultAddress,
                toSpend: [],
                toReceive: [
                    {
                        token: asset,
                        amount: borrowAmount.value,
                    },
                ],
            },
            {
                address: to.value,
                toSpend: [
                    {
                        token: asset,
                        amount: borrowAmount.value,
                    },
                ],
                toReceive: [],
            },
        ];
    },
});
